import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Alert, Statistic, message } from "antd";
import { useEffect, useState } from "react";
const { Countdown } = Statistic;
const Index = (props) => {
  const [phone, setPhone] = useState("");
  const [sended, setSended] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    props?.setCollect(null);
  }, []);

  const onChangePhone = (e) => {
    const value = e?.target?.value.replace(/\D/g, "");
    if (value.length <= 8) {
      setPhone(value);
    }
  };

  const handleVerify = () => {
    if (phone?.length === 8) {
      setLoading(true);
      props
        ?.request({ url: `/order/tryotp/${phone}`, method: "POST" })
        ?.then((res) => {
          setLoading(false);
          if (res?.success) {
            setSended(true);
            message.success(res.message);
          } else {
            message.error(res.message);
          }
        });
    } else message.error("Зөв утасны дугаар оруулна уу.");
  };

  const handleChangeOtp = (e) => {
    setLoading(true);
    props
      ?.request({ url: `/order/checkotp/${phone}/${e}`, method: "POST" })
      ?.then((res) => {
        setLoading(false);
        if (res?.success) {
          message.success(res.message);
          props?.setCollect({ ...props?.collect, phonen: phone });
          props?.setStep(props?.step + 1);
        } else {
          message.error(res.message);
        }
      });
  };

  const finishCountdown = () => {};

  return (
    <div className="w-full flex flex-col items-center">
      <div className="flex flex-col gap-3 w-full">
        <span className="font-bold">Хэрэглэгчийн мэдээлэл</span>
        <Alert
          type="info"
          message="Утасны дугаарт ирсэн кодыг оруулж баталгаажуулснаар үргэлжлүүлэх боломжтой."
          showIcon
        />
      </div>
      <div className="flex gap-2 mt-5 lg:mt-8 w-full lg:w-2/6">
        {sended ? (
          <div className="flex w-full w-full flex-col">
            <Alert
              type="warning"
              showIcon
              message={`${phone} утасны дугаарт баталгаажуулах код илгээлээ.`}
            />

            <div className="flex flex-col items-center w-full justify-center mt-5">
              <Input.OTP
                length={4}
                style={{ width: 200 }}
                disabled={loading}
                onChange={handleChangeOtp}
                type="number"
              />
              <div className="flex gap-2 items-center py-2">
                <Countdown
                  value={Date.now() + 180 * 1000}
                  format="mm:ss"
                  valueStyle={{
                    fontSize: "0.8rem",
                  }}
                  onFinish={finishCountdown}
                />
                <Button type="text" className="p-0 text-xs" disabled>
                  Дахин илгээх
                </Button>
              </div>
              <Button onClick={() => setSended(false)}>Буцах</Button>
            </div>
          </div>
        ) : (
          <div className="flex gap-2 w-full justify-center">
            <Input
              placeholder="Утасны дугаар"
              size="large"
              className="w-44"
              onChange={onChangePhone}
              value={phone}
            />
            <Button
              size="large"
              icon={<SearchOutlined />}
              type="primary"
              loading={loading}
              onClick={handleVerify}
            >
              Баталгаажуулах
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Index;
